/**
 * Markdown 只读展示（旧 components/common/MarkdownView.vue）。
 * 全项目唯一允许使用 dangerouslySetInnerHTML 的组件：内容先经 renderMarkdown 清洗。
 */
import { useMemo } from 'react'
import { renderMarkdown } from './markdown'
import styles from './MarkdownView.module.css'

interface MarkdownViewProps {
  content: string | null | undefined
  // 行内渲染，用于标题等单行文本
  inline?: boolean
}

export function MarkdownView({ content, inline = false }: Readonly<MarkdownViewProps>) {
  const html = useMemo(() => renderMarkdown(content ?? '', inline), [content, inline])
  const Tag = inline ? 'span' : 'div'
  return <Tag className={inline ? styles.inline : styles.block} dangerouslySetInnerHTML={{ __html: html }} />
}
